import '../../partials/content/faq/faq-search/faq-search';

export default new class faqComponent {
  constructor() {
    this.openButton = 'js_faq-left-menu-open__button';
    this.menuWrapper = 'faq-left__wrapper';
    this.openClass = 'faq-left-open__wrapper';

    this.handler();
  }

  handler() {
    $(document)
      .on('click', `.${this.openButton}`, () => {
        $(`.${this.menuWrapper}`).toggleClass(this.openClass);
      });
  }
}();
